const videoPopup = (block) => {
    const videoButtons = block 
        ? [block[0].querySelector(".bn-video__button")] 
        : document.querySelectorAll('.bn-video__button');

    if (!videoButtons.length) return;

    const footer = document.querySelector('.footer');

    let videosPopup = document.querySelector('.bn-video__popup');
    if (!videosPopup && footer) {
        videosPopup = document.createElement('div');
        videosPopup.classList.add('bn-video__popup');
        footer.prepend(videosPopup);
    }

    const closePopup = () => {
        videosPopup.classList.remove('--active');
        videosPopup.innerHTML = '';
    };

    function onPlayerReady(event) {
        event.target.playVideo();
    }

    videoButtons.forEach(button => {
        const videoElement = button.closest('.bn-video');
        const blockKey = videoElement.dataset.blockKey;
        const videoId = videoElement.dataset.videoId;
        const videoCover = videoElement.querySelector('.bn-video__cover');

        button.addEventListener('click', () => {
            if (button.dataset.video) {
                videosPopup.classList.add('--active');
                const iframe = videosPopup.querySelector('iframe');
                if (!iframe) {
                    videosPopup.innerHTML = '';
                    let iframe = document.createElement('div');
                    iframe.id = blockKey;
                    videosPopup.append(iframe);
                }
            } else {
                if (videoCover) videoCover.style.display = 'none';
            }

            new window.YT.Player(blockKey, {
                videoId: videoId,
                events: {
                    'onReady': onPlayerReady
                }
            });
        });
    });

    videosPopup.addEventListener('click', (e) => {
        if (e.target === videosPopup) closePopup();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && videosPopup.classList.contains('--active')) {
            closePopup();
        }
    });
};

document.addEventListener("DOMContentLoaded", () => {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body')) {
        videoPopup();
    }
});